export default {
	computed: {
		userCan() {
			return this.$store.getters.userCan
		},
		currentUser() {
			return this.$store.getters.currentUser
		},
		currentSettings() {
			return this.$store.getters.currentSettings
		},
		isSysAdmin() {
			return this.$store.getters.isSysAdmin
		}
	}
}